import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";

import { Spinner, SPINNER_SIZES } from "widgets/spinner";

import { ProcessService } from "../services/process.service.js";
import { StudioComponent } from "./studio.component";

import styles from "./studio.css";

export function StudioWrapperComponent() {
  const match = useRouteMatch();
  const history = useHistory();
  const [processInfo, setProcessInfo] = useState(null);

  let params = match["params"];
  let modelId = params["modelId"];

  useEffect(
    function getProcessDetails() {
      getProcessInfo();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modelId]
  );

  const onClose = () => {
    if (history.location.state?.fromCreate) {
      history.push(`/process/${modelId}/myitems`);
    } else if (history.length > 2) {
      history.goBack();
    } else {
      history.push(`/process/${modelId}`);
    }
  };

  function getProcessInfo() {
    const [progress] = ProcessService.getFlowInfo(modelId);
    progress()
      .then((processInfo) => setProcessInfo(processInfo))
      .catch((err) => {
        console.error("failed to get process data", err);
      });
  }
  return processInfo ? (
    <StudioComponent
      flowType={"Process"}
      flowId={modelId}
      flowInfo={processInfo}
      match={match}
      history={history}
      refreshProcess={() => {}}
      onClose={onClose}
    />
  ) : (
    <div className={styles.centerLoading}>
      <Spinner size={SPINNER_SIZES.MEDIUM} />
    </div>
  );
}
